import OneRecording from "./OneRecording";

const Recordings = ({ loggedInUser, hasPurchased, event, isReplay }: any) => {
  return (
    <div>
      {loggedInUser && isReplay === 1 ? (
        <>
          {hasPurchased && (
            <div className="mt-8">
              <div className="w-[95%] mx-auto max-sm:w-[98%] rounded-2xl border border-white/10 bg-white/[0.02] px-5 py-6 backdrop-blur-sm">
                <div className="mb-4 flex items-center justify-between">
                  <h3 className="flex items-center gap-2 text-xl font-bold text-white">
                    <span className="h-5 w-1.5 rounded-full bg-[#f30543]" />
                    Recordings
                  </h3>
                  <p className="rounded-full border border-white/10 bg-white/5 px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-white/60">
                    {event?.replay_videos.length} available
                  </p>
                </div>
                <div
                  className={`flex flex-col gap-2.5 ${
                    event?.replay_videos.length > 3
                      ? `custom-scrollbar h-[320px] w-full overflow-y-scroll overflow-x-hidden pr-1`
                      : ``
                  }`}
                >
                  {event?.replay_videos?.map((replayEvent: any, i: number) => (
                    <OneRecording key={i} recording={replayEvent} event={event} />
                  ))}
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Recordings;
